$(window).on('scroll resize orientationchange', function(){

  if ($(window).width() > 767) {
		$('.blockAnim').each( function(i){
		  var top_of_object = $(this).offset().top;
		  var bottom_of_window = $(window).scrollTop() + $(window).height();
		  
		  if(bottom_of_window > top_of_object){
		    $(this).animate({'margin-top': '-10rem'},400);
		  }
		});
  }

});